import { APIMethod, fetchData } from "@client";
import { DEFAULT_LABEL_COLOR, DEFAULT_LABEL_FONT_COLOR } from "@utils";

export async function createLabelQuery(
  name,
  color=DEFAULT_LABEL_COLOR,
  fontColor=DEFAULT_LABEL_FONT_COLOR,
  group, // from utils/labelGroups
) {
  const res = await fetchData(
    "/v1/labels",
    APIMethod.POST,
    {
      data: {
        name,
        color,
        font: fontColor,
        group
      }
    }
  );
  return res.results?.id;
}